import { useMutation } from '@tanstack/react-query';
import { duplicateTasks } from 'shared/services/backend-api';
import { Task } from 'shared/types/task';

export const useDuplicateTasksMutation = () =>
  useMutation({
    mutationFn: async (tasks: Task[]) => duplicateTasks(tasks),
  });
